module.exports = require("@swa-ui/hotel/src/components/HotelContainer/HotelContainer.module.scss");